import { render, staticRenderFns } from "./Setup_FlightsClassesExceptions.vue?vue&type=template&id=2d12ab51&scoped=true&"
import script from "./Setup_FlightsClassesExceptions.vue?vue&type=script&lang=js&"
export * from "./Setup_FlightsClassesExceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12ab51",
  null
  
)

export default component.exports